import React, { Component } from 'react';
import { Table, Icon, Popover } from 'antd';
import moment from 'moment';

const DateFormat = 'YYYY-MM-DD';

class MyWeeklyTable extends Component {
    getColumns = () => {
        const { data, showNextWeekPlan, beginWeek } = this.props;
        const { investigationName, investigationCode, investigationSiteName, investigationSiteCode, roleCode, investigationId, investigationSiteId, roleId, invEndDate } = data;
        const { userId } = sessionStorage;
        const params = { userId, investigationId, investigationSiteId, roleId };
        let titleNode = null;
        if (investigationSiteCode || investigationSiteName) {
            titleNode = <span>{`${investigationName}${investigationCode && investigationCode != '-' ? `(${investigationCode})` : ''}`}<br/>{`${investigationSiteName}(${investigationSiteCode})—${roleCode}`}</span>;
        } else {
            titleNode = <span>{`${investigationName}${investigationCode && investigationCode != '-' ? `(${investigationCode})` : ''}—${roleCode}`}</span>
        }
        const isShow = invEndDate ? moment(beginWeek).week() >= moment(invEndDate).week() : true;
        return [{
            title: titleNode,
            children: [{
                title: '序号',
                dataIndex: 'index',
                key: 'index',
                width: 85,
            }, {
                title: '工作类型',
                dataIndex: 'enterpriseWorkNameValue',
                key: 'enterpriseWorkNameValue',
                width: 100,
                render: (value, row, index) => {
                    const obj = {
                        children: value,
                        props: {},
                    };
                    if (row.index == '总计') {
                        obj.props.colSpan = 9;
                    } else if (row.index == '本周备注') {
                        obj.props.colSpan = 9;
                        obj.children = (
                            <span>
                                <span>{obj.children}</span>
                                {
                                    isShow &&
                                    <Icon
                                        type="edit"
                                        style={{ fontSize: 16, color: '#008dff', float: 'right', cursor: 'pointer' }}
                                        onClick={() => showNextWeekPlan({...params, enterpriseWorkNameValue: row.enterpriseWorkNameValue, type: 'comment'})}
                                    />
                                }
                            </span>
                        );
                    } else if (row.index == '下周计划') {
                        obj.props.colSpan = 9;
                        obj.children = (
                            <span>
                                <span>{obj.children}</span>
                                {
                                    isShow &&
                                    <Icon
                                        type="edit"
                                        style={{ fontSize: 16, color: '#008dff', float: 'right', cursor: 'pointer' }}
                                        onClick={() => showNextWeekPlan({...params, enterpriseWorkNameValue: row.enterpriseWorkNameValue, type: 'plan'})}
                                    />
                                }
                            </span>
                        );
                    } 
                    return obj;
                }
            }, {
                title: '工作名称',
                dataIndex: 'enterpriseWorkTypeName',
                key: 'enterpriseWorkTypeName',
                width: 170,
                render: (value, row, index) => {
                    const obj = {
                        children: value,
                        props: {},
                    };
                    if (row.index == '总计') {
                        obj.props.colSpan = 0;
                    } else if (row.index == '本周备注' || row.index == '下周计划') {
                        obj.props.colSpan = 0;
                    }
                    return obj;
                }
            }]
        }, {
            title: '周一',
            children: [{
                title: beginWeek.format(DateFormat),
                dataIndex: 'monDay',
                key: 'monDay',
                width: 85,
                render: (value, row, index) => {
                    const obj = {
                        children: value,
                        props: {},
                    };
                    if (row.index == '总计') {
                        obj.props.colSpan = 0;
                    } else if (row.index == '本周备注' || row.index == '下周计划') {
                        obj.props.colSpan = 0;
                    }
                    if (row.enterpriseWorkNameValue == '患者访视' && row.monDay.props.tip) {
                        const list = row.monDay.props.tip.split(';');
                        const node = list.map(item => <div>{item}</div>);
                        obj.children = <Popover placement="right" overlayClassName="gray-pop" content={node}>
                                            <div>
                                                <i className='pop'></i>
                                                {value}
                                            </div>
                                        </Popover>
                    }
                    if (row.enterpriseWorkNameValue == '其他' && row.enterpriseWorkTypeName == '其他项目相关' && row.monDay.props.tip) {
                        const len = Math.ceil(row.monDay.props.tip.length / 10);
                        const node = [];
                        for (let i = 0; i < len; i++ ) {
                            node.push(<p key={i}>{row.monDay.props.tip.slice(i * 10, (i + 1) * 10)}</p>);
                        }
                        obj.children = <Popover placement="right" overlayClassName="gray-pop" content={node}>
                                            <div>
                                                <i className='pop'></i>
                                                {value}
                                            </div>
                                        </Popover>
                    }
                    return obj;
                }
            }]
        }, {
            title: '周二',
            children: [{
                title: moment(beginWeek).add(1, 'days').format(DateFormat),
                dataIndex: 'tuesDay',
                key: 'tuesDay',
                width: 85,
                render: (value, row, index) => {
                    const obj = {
                        children: value,
                        props: {},
                    };
                    if (row.index == '总计') {
                        obj.props.colSpan = 0;
                    } else if (row.index == '本周备注' || row.index == '下周计划') {
                        obj.props.colSpan = 0;
                    }
                    if (row.enterpriseWorkNameValue == '患者访视' && row.tuesDay.props.tip) {
                        const list = row.tuesDay.props.tip.split(';');
                        const node = list.map(item => <div>{item}</div>);
                        obj.children = <Popover placement="right" overlayClassName="gray-pop" content={node}>
                                            <div>
                                                <i className='pop'></i>
                                                {value}
                                            </div>
                                        </Popover>
                    }
                    if (row.enterpriseWorkNameValue == '其他' && row.enterpriseWorkTypeName == '其他项目相关' && row.tuesDay.props.tip) {
                        const len = Math.ceil(row.tuesDay.props.tip.length / 10);
                        const node = [];
                        for (let i = 0; i < len; i++ ) {
                            node.push(<p key={i}>{row.tuesDay.props.tip.slice(i * 10, (i + 1) * 10)}</p>);
                        }
                        obj.children = <Popover placement="right" overlayClassName="gray-pop" content={node}>
                                            <div>
                                                <i className='pop'></i>
                                                {value}
                                            </div>
                                        </Popover>
                    }
                    return obj;
                }
            }]
        }, {
            title: '周三',
            children: [{
                title: moment(beginWeek).add(2, 'days').format(DateFormat),
                dataIndex: 'wednesday',
                key: 'wednesday',
                width: 85,
                render: (value, row, index) => {
                    const obj = {
                        children: value,
                        props: {},
                    };
                    if (row.index == '总计') {
                        obj.props.colSpan = 0;
                    } else if (row.index == '本周备注' || row.index == '下周计划') {
                        obj.props.colSpan = 0;
                    }
                    if (row.enterpriseWorkNameValue == '患者访视' && row.wednesday.props.tip) {
                        const list = row.wednesday.props.tip.split(';');
                        const node = list.map(item => <div>{item}</div>);
                        obj.children = <Popover placement="right" overlayClassName="gray-pop" content={node}>
                                            <div>
                                                <i className='pop'></i>
                                                {value}
                                            </div>
                                        </Popover>
                    }
                    if (row.enterpriseWorkNameValue == '其他' && row.enterpriseWorkTypeName == '其他项目相关' && row.wednesday.props.tip) {
                        const len = Math.ceil(row.wednesday.props.tip.length / 10);
                        const node = [];
                        for (let i = 0; i < len; i++ ) {
                            node.push(<p key={i}>{row.wednesday.props.tip.slice(i * 10, (i + 1) * 10)}</p>);
                        }
                        obj.children = <Popover placement="right" overlayClassName="gray-pop" content={node}>
                                            <div>
                                                <i className='pop'></i>
                                                {value}
                                            </div>
                                        </Popover>
                    }
                    return obj;
                }
            }]
        }, {
            title: '周四',
            children: [{
                title: moment(beginWeek).add(3, 'days').format(DateFormat),
                dataIndex: 'thursDay',
                key: 'thursDay',
                width: 85,
                render: (value, row, index) => {
                    const obj = {
                        children: value,
                        props: {},
                    };
                    if (row.index == '总计') {
                        obj.props.colSpan = 0;
                    } else if (row.index == '本周备注' || row.index == '下周计划') {
                        obj.props.colSpan = 0;
                    }
                    if (row.enterpriseWorkNameValue == '患者访视' && row.thursDay.props.tip) {
                        const list = row.thursDay.props.tip.split(';');
                        const node = list.map(item => <div>{item}</div>);
                        obj.children = <Popover placement="right" overlayClassName="gray-pop" content={node}>
                                            <div>
                                                <i className='pop'></i>
                                                {value}
                                            </div>
                                        </Popover>
                    }
                    if (row.enterpriseWorkNameValue == '其他' && row.enterpriseWorkTypeName == '其他项目相关' && row.thursDay.props.tip) {
                        const len = Math.ceil(row.thursDay.props.tip.length / 10);
                        const node = [];
                        for (let i = 0; i < len; i++ ) {
                            node.push(<p key={i}>{row.thursDay.props.tip.slice(i * 10, (i + 1) * 10)}</p>);
                        }
                        obj.children = <Popover placement="right" overlayClassName="gray-pop" content={node}>
                                            <div>
                                                <i className='pop'></i>
                                                {value}
                                            </div>
                                        </Popover>
                    }
                    return obj;
                }
            }]
        }, {
            title: '周五',
            children: [{
                title: moment(beginWeek).add(4, 'days').format(DateFormat),
                dataIndex: 'friday',
                key: 'friday',
                width: 85,
                render: (value, row, index) => {
                    const obj = {
                        children: value,
                        props: {},
                    };
                    if (row.index == '总计') {
                        obj.props.colSpan = 0;
                    } else if (row.index == '本周备注' || row.index == '下周计划') {
                        obj.props.colSpan = 0;
                    }
                    if (row.enterpriseWorkNameValue == '患者访视' && row.friday.props.tip) {
                        const list = row.friday.props.tip.split(';');
                        const node = list.map(item => <div>{item}</div>);
                        obj.children = <Popover placement="right" overlayClassName="gray-pop" content={node}>
                                            <div>
                                                <i className='pop'></i>
                                                {value}
                                            </div>
                                        </Popover>
                    }
                    if (row.enterpriseWorkNameValue == '其他' && row.enterpriseWorkTypeName == '其他项目相关' && row.friday.props.tip) {
                        const len = Math.ceil(row.friday.props.tip.length / 10);
                        const node = [];
                        for (let i = 0; i < len; i++ ) {
                            node.push(<p key={i}>{row.friday.props.tip.slice(i * 10, (i + 1) * 10)}</p>);
                        }
                        obj.children = <Popover placement="right" overlayClassName="gray-pop" content={node}>
                                            <div>
                                                <i className='pop'></i>
                                                {value}
                                            </div>
                                        </Popover>
                    }
                    return obj;
                }
            }]
        }, {
            title: '周六',
            children: [{
                title: moment(beginWeek).add(5, 'days').format(DateFormat),
                dataIndex: 'saturDay',
                key: 'saturDay',
                width: 85,
                render: (value, row, index) => {
                    const obj = {
                        children: value,
                        props: {},
                    };
                    if (row.index == '总计') {
                        obj.props.colSpan = 0;
                    } else if (row.index == '本周备注' || row.index == '下周计划') {
                        obj.props.colSpan = 0;
                    }
                    if (row.enterpriseWorkNameValue == '患者访视' && row.saturDay.props.tip) {
                        const list = row.saturDay.props.tip.split(';');
                        const node = list.map(item => <div>{item}</div>);
                        obj.children = <Popover placement="right" overlayClassName="gray-pop" content={node}>
                                            <div>
                                                <i className='pop'></i>
                                                {value}
                                            </div>
                                        </Popover>
                    }
                    if (row.enterpriseWorkNameValue == '其他' && row.enterpriseWorkTypeName == '其他项目相关' && row.saturDay.props.tip) {
                        const len = Math.ceil(row.saturDay.props.tip.length / 10);
                        const node = [];
                        for (let i = 0; i < len; i++ ) {
                            node.push(<p key={i}>{row.saturDay.props.tip.slice(i * 10, (i + 1) * 10)}</p>);
                        }
                        obj.children = <Popover placement="right" overlayClassName="gray-pop" content={node}>
                                            <div>
                                                <i className='pop'></i>
                                                {value}
                                            </div>
                                        </Popover>
                    }
                    return obj;
                }
            }]
        }, {
            title: '周日',
            children: [{
                title: moment(beginWeek).add(6, 'days').format(DateFormat),
                dataIndex: 'sunday',
                key: 'sunday',
                width: 85,
                render: (value, row, index) => {
                    const obj = {
                        children: value,
                        props: {},
                    };
                    if (row.index == '总计') {
                        obj.props.colSpan = 0;
                    } else if (row.index == '本周备注' || row.index == '下周计划') {
                        obj.props.colSpan = 0;
                    }
                    if (row.enterpriseWorkNameValue == '患者访视' && row.sunday.props.tip) {
                        const list = row.sunday.props.tip.split(';');
                        const node = list.map(item => <div>{item}</div>);
                        obj.children = <Popover placement="right" overlayClassName="gray-pop" content={node}>
                                            <div>
                                                <i className='pop'></i>
                                                {value}
                                            </div>
                                        </Popover>
                    }
                    if (row.enterpriseWorkNameValue == '其他' && row.enterpriseWorkTypeName == '其他项目相关' && row.sunday.props.tip) {
                        const len = Math.ceil(row.sunday.props.tip / 10);
                        const node = [];
                        for (let i = 0; i < len; i++ ) {
                            node.push(<p key={i}>{row.sunday.props.tip.slice(i * 10, (i + 1) * 10)}</p>);
                        }
                        obj.children = <Popover placement="right" overlayClassName="gray-pop" content={node}>
                                            <div>
                                                <i className='pop'></i>
                                                {value}
                                            </div>
                                        </Popover>
                    }
                    return obj;
                }
            }]
        }];
    }

    getDataSource = () => {
        const dataSource = [];
        const { data = {} } = this.props;
        const { workTypes = [], totalManhour, nextWeekComment, thisWeekComment } = data;
        if (workTypes && workTypes.length > 0) {
            workTypes.map((item, index) => {
                dataSource.push({
                    index: index + 1,
                    enterpriseWorkNameValue: item.enterpriseWorkNameValue,
                    enterpriseWorkTypeName: item.enterpriseWorkTypeName,
                    monDay: <span tip={item.dateValues[0].manHourVisitTip ? item.dateValues[0].manHourVisitTip : item.dateValues[0].remarks}>{item.dateValues[0].dateValue}</span>,
                    tuesDay: <span tip={item.dateValues[1].manHourVisitTip  ? item.dateValues[1].manHourVisitTip : item.dateValues[1].remarks}>{item.dateValues[1].dateValue}</span>,
                    wednesday: <span tip={item.dateValues[2].manHourVisitTip  ? item.dateValues[2].manHourVisitTip : item.dateValues[2].remarks}>{item.dateValues[2].dateValue}</span>,
                    thursDay: <span tip={item.dateValues[3].manHourVisitTip  ? item.dateValues[3].manHourVisitTip : item.dateValues[3].remarks}>{item.dateValues[3].dateValue}</span>,
                    friday: <span tip={item.dateValues[4].manHourVisitTip  ? item.dateValues[4].manHourVisitTip : item.dateValues[4].remarks}>{item.dateValues[4].dateValue}</span>,
                    saturDay: <span tip={item.dateValues[5].manHourVisitTip  ? item.dateValues[5].manHourVisitTip : item.dateValues[5].remarks}>{item.dateValues[5].dateValue}</span>,
                    sunday: <span tip={item.dateValues[6].manHourVisitTip  ? item.dateValues[6].manHourVisitTip : item.dateValues[6].remarks}>{item.dateValues[6].dateValue}</span>,
                });
            });
            dataSource.push({
                index: '总计',
                enterpriseWorkNameValue: totalManhour,
            });
        }
        dataSource.push({
            index: '本周备注',
            enterpriseWorkNameValue: thisWeekComment,
        });
        dataSource.push({
            index: '下周计划',
            enterpriseWorkNameValue: nextWeekComment,
        });
        return dataSource;
    };

    render () {
        const { loading } = this.props;
        return (
            <Table
                columns={this.getColumns()}
                dataSource={this.getDataSource()}
                rowKey={record => record.index}
                loading={loading}
                scroll={{x: 950}}
                style={{marginBottom: 40}}
                pagination={ false }
                className='crcWeekly'
            />
        )
    }
}

export default MyWeeklyTable;


// WEBPACK FOOTER //
// ./src/components/manHour/MyWeeklyTable.js